import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfigService } from '@core/services/config.service';
import { appAnimations } from '@core/animations';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../../../../../services/auth/auth.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { AppAlertDialogComponent } from '@core/components/alert/alert-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { AppUtils } from '@core/appUtils';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    animations: appAnimations,
    providers: [AuthService]
})
export class AppForgotPasswordComponent implements OnInit {
    regForm: FormGroup;
    loading = false;
    regFormErrors: any;
    confirmDialogRef: MatDialogRef<AppAlertDialogComponent>;
    constructor(
        private appConfig: AppConfigService,
        private formBuilder: FormBuilder,
        private router: Router,
        private _authService: AuthService,
        public dialog: MatDialog,
        private toast: ToastrService,
        private _appConfig: AppConfigService
    ) {
        this._appConfig.setSettings({
            layout: {
                header: {
                    home: false,
                    register: true,
                    fixed: true
                },
                footer: {
                    home: false,
                    register: true,
                    fixed: true
                }
            }
        });

        this.regFormErrors = {
            email: {}
        };
    }

    ngOnInit() {
        this.regForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]]
        });

        this.regForm.valueChanges.subscribe(() => {
            this.onregFormValuesChanged();
        });
    }

    onregFormValuesChanged() {
        for (const field in this.regFormErrors) {
            if (!this.regFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.regFormErrors[field] = {};

            // Get the control
            const control = this.regForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.regFormErrors[field] = control.errors;
            }
        }
    }

    onSubmit() {
        if (this.regForm.valid) {
            this.loading = true;
            const data = this.regForm.getRawValue();
            this._authService.forgot_password(data).subscribe(
                (res: any) => {
                    this.loading = false;
                    this.alert('Revisa tu bandeja de correo.');
                    this.regForm.reset();
                },

                (err: any) => {
                    this.loading = false;
                    if ( err.code === 400) {
                        if (!Boolean(err.status)) {
                            const msg = AppUtils.showError(err);
                            this.alert(msg);
                        }
                    }else {
                        this.alert('Ocurrió un error, inténtalo nuevamente.');
                    }
                }
            );
        }
    }

    activeSettings() {
        this.appConfig.setSettings({
            layout: {
                navigation: 'left',
                toolbar: 'above'
            }
        });
    }

    alert(msg?: any) {
        this.confirmDialogRef = this.dialog.open(AppAlertDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.alertMessage = msg;

        this.confirmDialogRef.afterClosed().subscribe(result => {
            this.confirmDialogRef = null;
        });
    }
}
